/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Column } from "App/Models";

/* Static (non-sortable) columns: invoices are listed straight from Stripe, the backend does not
   support server-side sorting on them. Order mirrors the Facturation mockup. */
function Get(): Column[] {
    return [
        Column.Static( "Total", $t( "PAYMENTS_columnTotal" ) ),
        Column.Static( "Frequency", $t( "PAYMENTS_columnFrequency" ) ),
        Column.Static( "Number", $t( "PAYMENTS_columnNumber" ) ),
        Column.Static( "CustomerName", $t( "PAYMENTS_columnCustomerName" ) ),
        Column.Static( "CustomerEmail", $t( "PAYMENTS_columnCustomerEmail" ) ),
        Column.Static( "DueDate", $t( "PAYMENTS_columnDueDate" ) ),
        Column.Static( "CreatedAt", $t( "PAYMENTS_columnCreatedAt" ) )
    ];
}

export default {
    Get
};
